import { render } from "./MessageOutput.vue?vue&type=template&id=3a724299"
import script from "./MessageOutput.vue?vue&type=script&lang=js"
export * from "./MessageOutput.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__